<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<div class="dialog-shell">
  <div class="dialog-shell__header">
    <div class="dialog-shell__heading">
      <h2 class="dialog-shell__title">{{ title() }}</h2>
      @if (description()) {
        <p class="dialog-shell__description">{{ description() }}</p>
      }
    </div>
    <button
      class="dialog-shell__close"
      type="button"
      [disabled]="closeDisabled()"
      [attr.aria-label]="'translations.global.ariaLabels.closeDialog' | transloco"
      (click)="closed.emit()"
    >
      <ptl-icon [icon]="LucideX" size="m"></ptl-icon>
    </button>
  </div>

  <div class="dialog-shell__separator"></div>

  <div class="dialog-shell__content">
    <ng-content></ng-content>
  </div>

  <div class="dialog-shell__separator"></div>

  <div class="dialog-shell__footer">
    <ng-content select="[dialogFooter]"></ng-content>
  </div>
</div>
